import Tiles from './Tiles';

export default Tiles;
